// components/pages/delivery-clearance/DeliveryClearancePrint.jsx
import React, { Component } from 'react';
import '../../../../../styles/components/delivery-clearance-print.scss';

class DeliveryClearancePrint extends Component {
  constructor(props) {
    super(props);
    this.printRef = React.createRef();
  }

  formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return '';
    }
  };

  getSafeValue = (obj, path, defaultValue) => {
    try {
      const value = path.split('.').reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
      return value !== undefined ? value : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  };

  render() {
    const {
      auction = {},
      group = {},
      winner = {},
      signature = {},
      refNo,
      documentType = 'clearance', // 'clearance' = pre-collection (Operator + Bidder/Collector) | 'approval' = post-delivery (Operator only)
    } = this.props;

    const isApprovalDoc = documentType === 'approval';

    const auctionId = this.getSafeValue(auction, 'id', 'N/A');
    const itemDescription = this.getSafeValue(auction, 'title', 'N/A');
    const lotNumber = this.getSafeValue(group, 'id', this.getSafeValue(auction, 'group', 'N/A'));

    const bidderName = this.getSafeValue(winner, 'name', 'N/A');
    const userId = this.getSafeValue(winner, 'id', 'N/A');

    const certificateRef = refNo || `CC-${auctionId}/${new Date().getFullYear()}`;
    const collectionAuthRef = this.getSafeValue(signature, 'sign_token', 'N/A');

    const operatorName = this.getSafeValue(signature, 'operator_name', 'Mzadcom Operator');
    const operatorSignedAt = this.getSafeValue(signature, 'operator_signed_at', '');
    const operatorSignatureUrl = this.getSafeValue(signature, 'operator_signature_url', '');

    const winnerSignedAt = this.getSafeValue(signature, 'winner_signed_at', '');
    const winnerSignatureUrl = this.getSafeValue(signature, 'winner_signature_url', '');
    const collectorName = this.getSafeValue(signature, 'collector_name', '');

    const completionSignedAt = this.getSafeValue(signature, 'completion_signed_at', '');
    const completionSignatureUrl = this.getSafeValue(signature, 'completion_signature_url', '');

    const currentDate = new Date().toLocaleDateString('en-GB');

    const titleEn = isApprovalDoc ? 'DELIVERY APPROVAL CERTIFICATE' : 'DELIVERY CLEARANCE CERTIFICATE';
    const titleAr = isApprovalDoc ? 'شهادة الموافقة على التسليم' : 'شهادة تخليص التسليم';

    return (
      <div ref={this.props.forwardedRef || this.printRef} className="delivery-clearance-invoice">
        <div className="dc-invoice-wrapper">
          {/* Header */}
          <div className="dc-invoice-header">
            <div className="dc-company-info">
              <img
                src={process.env.PUBLIC_URL + '/assets/images/logo-org.png'}
                alt="Mzadcom"
                className="dc-invoice-logo"
              />
            </div>

            <div className="dc-company-text">
              <h1 className="dc-company-name">Mzadcom Smart Auction Solutions LLC</h1>
              <h1 className="dc-company-name-ar">مزادكم لحلول المزادات الذكية ش.م.م</h1>
            </div>

            <div className="dc-invoice-title-section">
              <h2 className="dc-invoice-title">{titleEn}</h2>
              <h2 className="dc-invoice-title-ar">{titleAr}</h2>
              <div className="dc-invoice-number">
                <div className="dc-number-row">
                  <span className="label">Ref No:</span>
                  <span className="value">{certificateRef}</span>
                  <span className="label-ar rtl-text">الرقم المرجعي</span>
                </div>
              </div>
            </div>
          </div>

          {/* Details */}
          <div className="dc-invoice-details">
            <div className="dc-details-section">
              <div className="dc-detail-row">
                <div className="dc-detail-item">
                  <span className="label">Date:</span>
                  <span className="value">{currentDate}</span>
                  <span className="label-ar rtl-text">التاريخ :</span>
                </div>
              </div>
            </div>
          </div>

          {/* Subject / Certification statement */}
          <div className="dc-statement-section">
            {isApprovalDoc ? (
              <>
                <p className="dc-statement-en">
                  This is to certify that the auction item detailed below has been physically delivered to,
                  and collected by, the successful bidder (or their authorized representative), and that
                  the delivery process has been completed in full.
                </p>
                <p className="dc-statement-ar rtl-text">
                  نشهد بموجب هذا أن العنصر المذكور أدناه من المزاد قد تم تسليمه فعليًا واستلامه من قبل المزايد الفائز
                  (أو من ينوب عنه رسميًا)، وأن عملية التسليم قد تمت بالكامل.
                </p>
              </>
            ) : (
              <>
                <p className="dc-statement-en">
                  This is to certify that the following auction item has been successfully collected by
                  the successful bidder and the transaction has been completed.
                </p>
                <p className="dc-statement-ar rtl-text">
                  نشهد بموجب هذا أن العنصر التالي المعروض في المزاد قد تم استلامه بنجاح من قبل المزايد،
                  وأن المعاملة قد تم استكمالها.
                </p>
              </>
            )}
          </div>

          {/* Auction Details */}
          <div className="dc-auction-section">
            <div className="dc-section-header">
              <h3>AUCTION DETAILS</h3>
              <h3 className="header-ar">تفاصيل المزاد</h3>
            </div>

            <div className="dc-info-grid">
              <div className="dc-info-column">
                <div className="dc-info-item">
                  <div className="label-row">
                    <div className="label">Auction ID:</div>
                    <div className="value-row">
                      <div className="value">MZAD {auctionId}</div>
                    </div>
                    <div className="label-ar">رقم المزاد</div>
                  </div>
                </div>

                <div className="dc-info-item">
                  <div className="label-row">
                    <div className="label">Item Description:</div>
                    <div className="value-row">
                      <div className="value">{itemDescription}</div>
                    </div>
                    <div className="label-ar">وصف السلعة</div>
                  </div>
                </div>

                <div className="dc-info-item">
                  <div className="label-row">
                    <div className="label">Lot / Group Number:</div>
                    <div className="value-row">
                      <div className="value">{lotNumber}</div>
                    </div>
                    <div className="label-ar">رقم المجموعة</div>
                  </div>
                </div>
              </div>

              <div className="dc-info-column">
                <div className="dc-info-item">
                  <div className="label-row">
                    <div className="label">Bidder Name:</div>
                    <div className="value-row">
                      <div className="value">{bidderName}</div>
                    </div>
                    <div className="label-ar">اسم المزايد</div>
                  </div>
                </div>

                <div className="dc-info-item">
                  <div className="label-row">
                    <div className="label">User ID:</div>
                    <div className="value-row">
                      <div className="value">{userId}</div>
                    </div>
                    <div className="label-ar">رقم تعريف المستخدم</div>
                  </div>
                </div>

                <div className="dc-info-item">
                  <div className="label-row">
                    <div className="label">Date of Collection:</div>
                    <div className="value-row">
                      <div className="value">
                        {this.formatDate(isApprovalDoc ? completionSignedAt : winnerSignedAt) || currentDate}
                      </div>
                    </div>
                    <div className="label-ar">تاريخ الاستلام</div>
                  </div>
                </div>

                {!isApprovalDoc && collectorName ? (
                  <div className="dc-info-item">
                    <div className="label-row">
                      <div className="label">Collected By:</div>
                      <div className="value-row">
                        <div className="value">{collectorName}</div>
                      </div>
                      <div className="label-ar">استلم بواسطة</div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* Confirmation */}
          <div className="dc-confirmation-section">
            <div className="dc-section-header">
              <h3>CONFIRMATION</h3>
              <h3 className="header-ar">التأكيد</h3>
            </div>
            {isApprovalDoc ? (
              <>
                <p className="dc-statement-en">
                  This document confirms final closure of the delivery process for the above-mentioned
                  auction item. The item has left company custody and no further handover obligation
                  remains on the part of Mzadcom Smart Auction Solutions LLC.
                </p>
                <p className="dc-statement-ar rtl-text">
                  تؤكد هذه الوثيقة الإغلاق النهائي لعملية التسليم الخاصة بالعنصر المذكور أعلاه. وقد غادر
                  العنصر عهدة الشركة، ولا يوجد أي التزام تسليم إضافي على عاتق شركة مزادكم لحلول المزادات
                  الذكية ش.م.م.
                </p>
              </>
            ) : (
              <>
                <p className="dc-statement-en">
                  The above-mentioned auction item has been released and collected from the site. All
                  applicable site formalities have been completed, and there is no pending obligation
                  related to the physical handover of the item. This certificate is issued for
                  transaction closure and for processing the refund of the bidder's Guarantee
                  Money/Security Deposit as per company procedures.
                </p>
                <p className="dc-statement-ar rtl-text">
                  تم تسليم العنصر المذكور أعلاه في المزاد واستلامه من الموقع. وقد تم استكمال جميع
                  الإجراءات الرسمية المطلوبة في الموقع، ولا توجد أي التزامات معلقة تتعلق بالتسليم الفعلي
                  للعنصر. يُصدر هذا الشهادة لإغلاق المعاملة ولمعالجة استرداد مبلغ الضمان الخاص بالمزايد
                  وفقًا لإجراءات الشركة.
                </p>
              </>
            )}
          </div>

          {/* Signatures */}
          <div className="dc-authorization-section">
            {isApprovalDoc ? (
              <div className="dc-signatures-grid dc-signatures-grid--single">
                <div className="dc-signature-block">
                  <h4 className="dc-auth-title">CONFIRMED BY — SITE TEAM REPRESENTATIVE</h4>
                  <h4 className="dc-auth-title-ar">تم التأكيد من قبل — ممثل فريق الموقع</h4>
                  <div className="dc-signature-area">
                    {completionSignatureUrl ? (
                      <img src={completionSignatureUrl} alt="Operator Signature" className="dc-signature-img" />
                    ) : (
                      <div className="dc-signature-line"></div>
                    )}
                    <div className="dc-signature-info">
                      <p className="dc-auth-name">{operatorName}</p>
                      <p className="dc-auth-role">
                        {completionSignedAt ? `Signed: ${this.formatDate(completionSignedAt)}` : 'Operator'}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="dc-signature-block dc-seal-block">
                  <h4 className="dc-auth-title">COMPANY SEAL</h4>
                  <h4 className="dc-auth-title-ar">ختم الشركة</h4>
                  <div className="dc-seal-area">
                    <img
                      src={process.env.PUBLIC_URL + '/assets/images/seal.png'}
                      alt="Company Seal"
                      className="dc-company-seal"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="dc-signatures-grid">
                <div className="dc-signature-block">
                  <h4 className="dc-auth-title">ISSUED BY — SITE TEAM REPRESENTATIVE</h4>
                  <h4 className="dc-auth-title-ar">صادر عن — ممثل فريق الموقع</h4>
                  <div className="dc-signature-area">
                    {operatorSignatureUrl ? (
                      <img src={operatorSignatureUrl} alt="Operator Signature" className="dc-signature-img" />
                    ) : (
                      <div className="dc-signature-line"></div>
                    )}
                    <div className="dc-signature-info">
                      <p className="dc-auth-name">{operatorName}</p>
                      <p className="dc-auth-role">
                        {operatorSignedAt ? `Signed: ${this.formatDate(operatorSignedAt)}` : 'Operator'}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="dc-signature-block">
                  <h4 className="dc-auth-title">VERIFIED BY — BIDDER</h4>
                  <h4 className="dc-auth-title-ar">تم التحقق من قبل — المزايد</h4>
                  <div className="dc-signature-area">
                    {winnerSignatureUrl ? (
                      <img src={winnerSignatureUrl} alt="Winner Signature" className="dc-signature-img" />
                    ) : (
                      <div className="dc-signature-line"></div>
                    )}
                    <div className="dc-signature-info">
                      <p className="dc-auth-name">{bidderName}</p>
                      <p className="dc-auth-role">
                        {winnerSignedAt ? `Signed: ${this.formatDate(winnerSignedAt)}` : 'Bidder / Winner'}
                      </p>
                      {collectorName ? <p className="dc-collector-name">Collected by: {collectorName}</p> : null}
                    </div>
                  </div>
                </div>

                <div className="dc-signature-block dc-seal-block">
                  <h4 className="dc-auth-title">COMPANY SEAL</h4>
                  <h4 className="dc-auth-title-ar">ختم الشركة</h4>
                  <div className="dc-seal-area">
                    <img
                      src={process.env.PUBLIC_URL + '/assets/images/seal.png'}
                      alt="Company Seal"
                      className="dc-company-seal"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="dc-footer-section">
            <div className="dc-terms-section">
              <div className="dc-terms-header">
                <h4>TERMS & CONDITIONS:</h4>
                <h4 className="terms-header-ar">الشروط والأحكام:</h4>
              </div>
              <div className="dc-terms-content">
                <div className="dc-term-item">
                  <p>1. This certificate is valid only with an authorized signature.</p>
                  <p className="term-ar">1. هذه الشهادة صالحة فقط مع توقيع مخول.</p>
                </div>
                <div className="dc-term-item">
                  <p>2. This certificate confirms full and final closure of the delivery transaction.</p>
                  <p className="term-ar">2. تؤكد هذه الشهادة الإغلاق الكامل والنهائي لمعاملة التسليم.</p>
                </div>
              </div>
            </div>

            <div className="dc-footer-info">
              <div className="dc-print-info">
                <p className="dc-cert-number">CERTIFICATE #{certificateRef}</p>
                <p className="dc-print-time">Printed: {currentDate}</p>
              </div>

              <div className="dc-contact-info">
                <p>Mzadcom Smart Auction Solution LLC</p>
                <p>Email: info@mzadcom.om</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ForwardedDeliveryClearancePrint = React.forwardRef((props, ref) => (
  <DeliveryClearancePrint {...props} forwardedRef={ref} />
));

export default ForwardedDeliveryClearancePrint;